import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, BRANDS, NAV_LINKS } from "@/constants/site";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer className="grain relative bg-navy-dark text-white" data-testid="footer">
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="inline-flex rounded-xl bg-white p-2">
              <img
                src="/logo.jpg"
                alt="GTA Appliance Rescue logo"
                className="h-14 w-auto"
              />
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Fast, reliable & local appliance repair across Toronto and the Greater Toronto Area.
              Licensed, insured, flat per-job pricing, and backed by a 1-year parts & 30-day labour warranty.
            </p>
          </div>

          <div>
            <h4 className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-red-400">
              Contact
            </h4>
            <ul className="mt-5 space-y-3.5 text-sm">
              <li>
                <a href={PHONE_TEL} className="flex items-center gap-2.5 text-slate-300 transition-colors hover:text-white" data-testid="footer-phone-link">
                  <Phone className="h-4 w-4 text-rescue" /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href="mailto:gtaappliancerescue@yahoo.com" className="flex items-center gap-2.5 text-slate-300 transition-colors hover:text-white" data-testid="footer-email-link">
                  <Mail className="h-4 w-4 text-rescue" /> gtaappliancerescue@yahoo.com
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-slate-300">
                <Clock className="h-4 w-4 text-rescue" /> 7 Days a Week, 7AM – 10PM
              </li>
              <li className="flex items-center gap-2.5 text-slate-300">
                <MapPin className="h-4 w-4 text-rescue" /> Toronto & the entire GTA
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-red-400">
              Quick Links
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToId(link.id)}
                    className="text-slate-300 transition-colors hover:text-white"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
              <li>
                <button
                  onClick={() => scrollToId("guides")}
                  className="text-slate-300 transition-colors hover:text-white"
                >
                  Repair Guides
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToId("request-service")}
                  className="font-semibold text-white transition-colors hover:text-red-300"
                >
                  Request Service
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-red-400">
              Brands We Service
            </h4>
            <div className="mt-5 flex flex-wrap gap-2">
              {BRANDS.map((brand) => (
                <span
                  key={brand}
                  className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-semibold text-slate-300"
                >
                  {brand}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 sm:flex-row">
          <p>© {new Date().getFullYear()} GTA Appliance Rescue. All rights reserved.</p>
          <p className="font-mono uppercase tracking-[0.2em]">Fast. Reliable. Done Right.</p>
          <a href="/admin" className="transition-colors hover:text-slate-300" data-testid="footer-admin-link">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
